import React, { useEffect, useState } from 'react';
import { ShieldCheck } from 'lucide-react';
import axiosClient from '../api/axiosClient';

export default function AuditLogsPage() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    axiosClient.get('/audit-logs').then((res) => setLogs(res.data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-black text-white tracking-tight flex items-center space-x-2">
          <ShieldCheck className="text-blue-500" />
          <span>Security & Audit Logs</span>
        </h1>
        <p className="text-xs text-slate-400 mt-1">Complete immutable record of all administrative actions, logins, and resource modifications</p>
      </div>

      <div className="bg-slate-900 border border-slate-800 rounded-2xl overflow-hidden shadow-xl">
        <table className="w-full text-left text-xs text-slate-300">
          <thead className="bg-slate-950 text-slate-400 uppercase font-bold text-[10px] tracking-wider border-b border-slate-800">
            <tr>
              <th className="px-6 py-4">Action</th>
              <th className="px-6 py-4">Entity</th>
              <th className="px-6 py-4">Administrator</th>
              <th className="px-6 py-4">IP Address</th>
              <th className="px-6 py-4">Timestamp</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-800/80 font-medium">
            {logs.map((l) => (
              <tr key={l.id} className="hover:bg-slate-800/40 transition-colors">
                <td className="px-6 py-4">
                  <span className="px-2.5 py-1 rounded-full text-[10px] font-bold bg-blue-500/10 text-blue-400 border border-blue-500/20">
                    {l.action}
                  </span>
                </td>
                <td className="px-6 py-4 font-bold text-white">{l.entity}</td>
                <td className="px-6 py-4 text-purple-300">{l.user?.name || 'System Admin'}</td>
                <td className="px-6 py-4 font-mono text-slate-400">{l.ipAddress || '127.0.0.1'}</td>
                <td className="px-6 py-4 text-slate-500">{new Date(l.createdAt).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
